import crmCustomerType from './crm-customer-type.js';

export const getCrmCustomerTypeOptions = async () => [
  {
    value: crmCustomerType.CRM_VALUE,
    label: 'kontrahent'
  },
  {
    value: crmCustomerType.CRM_SIMPLIFIED_VALUE,
    label: 'kontrahent uproszczony'
  },
  {
    value: crmCustomerType.CRM_AUTOMATIC_VALUE,
    label: 'kontrahent automatyczny'
  }
]; 